import { ILearning } from "./interfaces";
import { AxiosInstance } from "axios";

export function getLearningGradesBuilder(apiClient: AxiosInstance) {
  return async function getLearningGrades(): Promise<
    ILearning.LearningFilterMenuItem[] | null
  > {
    try {
      const response = await apiClient.get("/learning/api/grades/");
      return response.data.results;
    } catch {
      return null;
    }
  };
}
